export class RefreshToken {
  constructor(public refreshToken: string) {}
}
